// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Roboto/Inter werden non-blocking in public/index.html geladen */
* {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
}

/* Base styles with Roboto */
body {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.01em;
}

/* Headings with Roboto */
h1, h2, h3, h4, h5, h6 {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
  font-weight: 500;
  line-height: 1.2;
}

/* Input elements with Roboto */
input, textarea, select, button {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;
}

/* Roboto weight utilities */
.font-roboto-light {
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
}

.font-roboto-regular {
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
}

.font-roboto-medium {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
}

.font-roboto-bold {
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
}

.font-roboto-black {
  font-family: 'Roboto', sans-serif;
  font-weight: 900;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,2FAA2F;AAC7F;;AAEA,4BAA4B;AAC5B;EACE,2FAA2F;EAC3F,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,2FAA2F;EAC3F,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,2FAA2F;AAC7F;;AAEA,4BAA4B;AAC5B;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB","sourcesContent":["/* Roboto/Inter werden non-blocking in public/index.html geladen */\r\n* {\r\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;\r\n}\r\n\r\n/* Base styles with Roboto */\r\nbody {\r\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  letter-spacing: 0.01em;\r\n}\r\n\r\n/* Headings with Roboto */\r\nh1, h2, h3, h4, h5, h6 {\r\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;\r\n  font-weight: 500;\r\n  line-height: 1.2;\r\n}\r\n\r\n/* Input elements with Roboto */\r\ninput, textarea, select, button {\r\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif;\r\n}\r\n\r\n/* Roboto weight utilities */\r\n.font-roboto-light {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 300;\r\n}\r\n\r\n.font-roboto-regular {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 400;\r\n}\r\n\r\n.font-roboto-medium {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 500;\r\n}\r\n\r\n.font-roboto-bold {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 700;\r\n}\r\n\r\n.font-roboto-black {\r\n  font-family: 'Roboto', sans-serif;\r\n  font-weight: 900;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
